// ** React Imports
import { useContext } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { AbilityContext } from '@src/utility/context/Can';

// ** Third Party Components
import {
	UncontrolledDropdown,
	DropdownMenu,
	DropdownToggle,
	DropdownItem,
	Button
} from 'reactstrap';
import {
	User,
	Mail,
	CheckSquare,
	MessageSquare,
	Settings,
	CreditCard,
	HelpCircle,
	Power,
	ChevronDown,
	Bell
} from 'react-feather';

const SolicitudesDropdown = () => {
	const history = useHistory();
	const ability = useContext(AbilityContext);
	const canCancel = 
		ability.can('solicitar', 'cancelacion_ficha') || 
		ability.can('solicitar', 'cancelacion_caida') || 
		ability.can('solicitar', 'cancelacion_delito');
	const canAuth = ability.can('autorizar', 'cancelacion_ficha') ||
		ability.can('autorizar', 'cancelacion_caida') ||
		ability.can('autorizar', 'cancelacion_delito');
	return (
		(canCancel && canAuth) ?
		<UncontrolledDropdown  className="dropdown-user nav-item">
			<DropdownToggle
				href="/"
				tag="a"
				className="nav-link dropdown-user-link"
				onClick={(e) => e.preventDefault()}
			>
				<Bell size={22} />
			</DropdownToggle>
			<DropdownMenu right>
				<DropdownItem tag={Link} to='/solicitudes_pendientes' onClick={() => history.push('/solicitudes_pendientes')}>
					<span className="align-middle">Solicitudes Pendientes</span>
				</DropdownItem>
				<DropdownItem
					tag={Link}
					to='/solicitudes_autorizar'
					onClick={() => history.push('/solicitudes_autorizar')}
				>
					<span className="align-middle">Solicitudes por Autorizar</span>
				</DropdownItem>
			</DropdownMenu>
		</UncontrolledDropdown>
		 : (canCancel || canAuth) && <Button
		 size={'sm'}
		 color={'btn-gradient-grey'}
		 onClick={() => {
		 if (canCancel) { 
			 history.push('/solicitudes_pendientes');
		 } else {
			 if (canAuth) {
				 history.push('/solicitudes_autorizar');
			 }
		 }
	 }}
	 >
		 <Bell size={22} />
	 </Button>
	);
};

export default SolicitudesDropdown;
